import api from "../../../../services/axiosConfig";

export const fetchNotes = async () => {
  try {
    const response = await api.get("/instances/skeye/skeyenote/list-notes", {
      data: {},
    });
    return response.data.data.notes;
  } catch (error) {
    console.error("Error fetching notes:", error);
    throw error;
  }
};

export const addNote = async (newNote) => {
  try {
    const response = await api.post(
      "instances/skeye/skeyenote/create-note",
      newNote,
      { data: {} },
    );
    return response;
  } catch (error) {
    console.error("Error adding note:", error);
    throw error;
  }
};

export const deleteNote = async (noteId) => {
  try {
    const response = await api.delete(
      `/instances/skeye/skeyenote/delete-note/${noteId}`,
      {
        data: {},
      },
    );
    return response;
  } catch (error) {
    console.error("Error deleting note:", error);
    throw error;
  }
};

export const exportNote = async (noteId) => {
  try {
    const response = await api.get(
      `/instances/skeye/skeyenote/export-note/${noteId}`,
      {
        data: {},
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        maxBodyLength: Infinity,
      },
    );
    return response;
  } catch (error) {
    console.error("Error exporting note:", error);
    throw error;
  }
};

export const uploadNote = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await api.post(
      "/instances/skeye/skeyenote/import-note",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: {},
        timeout: 120000,
      },
    );
    return response;
  } catch (error) {
    console.error("Error uploading note:", error);
    throw error;
  }
};
